<template>
  <div class="user-agreement">
    <h1>青牛出关-动漫产品授权协议</h1>

    <!-- <p>青牛出关-动漫产品授权协议</p> -->
    <h2>甲方：被授权方</h2>
    <h2>乙方：北京青牛出关科技有限公司</h2>
    <p>鉴于：</p>
    <p>
      乙方运营picopi.cn青牛出关动漫网站，拥有原创正版动漫产品等动漫产品，致力于为包括但不限于自然人、企业等各类动漫产品需求者提供上述视觉内容；
    </p>
    <p>
      甲方在乙方运营的picopi.cn青牛出关动漫网站开通了账户，并有意通过该网站购买动漫产品；
    </p>
    <p>
      甲方为企业的，是依照国家统计局2017年12月28日颁布的《统计上大中小微型企业划分办法(2017)》所划分的中型、小型或微型企业，此协议的授权仅限于中小微企业使用；
    </p>
    <p>
      此授权协议为单一席位许可，即仅授权一位自然人下载和使用内容，其他人员（包括雇员、同事或第三方合作伙伴）均不得使用此授权协议下的甲方账户。如果甲方需要获取超过一个自然人的使用权限，或本协议下的授权不能满足需求，请联系乙方客服电话，升级至大客户专属协议。
    </p>
    <p>
      为充分发挥双方优势，互利共赢，根据《中华人民共和国著作权法》、《中华人民共和国民法典》等相关法律、法规之规定，针对乙方动漫产品的使用许可事宜，双方遵循平等、自愿、公平原则，达成如下协议并共同遵守。
    </p>
    <h2>1. 定义</h2>
<h3>1.1 动漫产品</h3>
<p>
  文学、艺术和科学等领域内具有独创性并能以某种有形形式复制的智力成果，本协议特指来自青牛出关动漫网站（www.picopi.cn）可提供授权许可的所有版权动漫产品的统称，包括但不限于表情包、创意漫画图片等产品。
</p>
<h3>1.2 青牛出关动漫网站</h3>
<p>
  乙方运营的动漫产品交易平台，网址为www.picopi.cn。
</p>
<h3>1.3 青牛出关网站账号</h3>
<p>
  甲方通过平台注册登录青牛出关动漫网站平台的，与甲方有一一指代关系的信息。
</p>
<h3>1.5 商业用途</h3>
<p>
  指在任何媒介上以直接或间接获取商业利益等经济利益为目的的场景中使用，包括但不限于印刷品、商业性的广播、电影或数字化产品、商业广告、市场推广、产品促销、产品包装产品介绍等场景。
</p>
<h3>1.6 标准授权</h3>
<p>
  乙方授权甲方在有限的商业用途中使用动漫产品，具体授权范围以本协议第三章为准。
</p>
<h3>1.7 动漫产品许可费</h3>
<p>
  乙方许可他人使用其享有著作权的或取得著作权许可的或代理他人进行著作权许可的动漫产品所应得的货币性对价。
</p>
<h3>1.9 中国法律</h3>
<p>
  任何中华人民共和国现行及未来颁布的法律、法规、规章、其他规范性文件及有约束力的政策（为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区之法律）。
</p>
<h2>第二章 声明与保证</h2>

<h3>2.1 乙方声明和保证：</h3>
<p>
  (1) 乙方已采取必要的公司行为和适当的授权，乙方或乙方授权代表有权签署本协议。<br>
  (2) 乙方在青牛出关网站上展示的动漫产品均已获得了适当的授权或乙方拥有版权，且乙方有权许可他人使用。<br>
  (3) 乙方在picopi.cn青牛出关动漫网站上展示的，原始未经更改且完全依照本协议和适用中国法律使用的动漫产品不会：
  <ul>
    <li>侵犯任何著作权、商标权或其他知识产权；</li>
    <li>侵犯任何第三方的隐私权或其他权利；</li>
    <li>违反任何中华人民共和国法律、法令、条例或法规。</li>
  </ul>
  (4) 乙方会尽商业上合理的努力来确保对内容进行描述的关键字和说明的准确性，但乙方未做出与以下任何方面有关的担保和/或陈述：
  <ul>
    <li>关键字、标题或说明；</li>
  </ul>
  (5) 除本协议声明与保证条款明确做出的保证之外，乙方未做出任何陈述或保证。
</p>

<h3>2.2 甲方声明和保证：</h3>
<p>
  (1) 甲方为自然人的，签署本协议时应当向乙方提供真实、有效的个人手机号，并按照乙方或picopi.cn青牛出关动漫网站提示，如实提供相关证件信息及材料。<br>
  (2) 甲方为机构的：
  <ul>
    <li>甲方合法设立并有效存续，并非清算、解散或破产程序之主体；</li>
    <li>甲方为企业的，应当是依照国家统计局2017年12月28日颁布的《统计上大中小微型企业划分办法(2017)》所划分的中型、小型或微型企业；</li>
    <li>甲方签署本协议时应当向乙方提供真实、有效的机构证明证件，包括但不限于企业营业执照、事业单位法人证书等，并按照乙方或picopi.cn青牛出关动漫网站提示，如实提供相关证件信息及材料。甲方提供的上述证件均应在有效期内，有效期届满的，甲方应于有效期届满之日起5个工作日内上传或以其他有效方式提供新的有效证件；</li>
    <li>甲方已采取必要的机构行为和适当的授权，甲方或甲方授权代表有权签署本协议。甲方联系人或授权代表应当向乙方提供机构的有效授权文件，并按照乙方或picopi.cn青牛出关动漫网站提示，如实提供上述文件，上述文件均应加盖甲方公章或同等效力签名；</li>
    <li>甲方就其所知，已向乙方披露了其知晓的包括但不限于经其注册地或营业地的政府部门签发的、可能对履行本协议项下义务产生重大不利影响的所有文件。</li>
  </ul>
  (3) 本协议的签署与履行及根据本协议所计划之商业交易在任何方面均不违反中国法律。<br>
  (4) 甲方妥善保管好其所有的青牛出关动漫网站账号，所有登录甲方账号、以甲方账号进行的行为，都视为甲方的行为，对甲方产生法律约束力。
</p>
<h2>第三章 授权许可</h2>

<h3>3.1</h3>
<p>
  乙方根据市场情况和用户需求，针对不同类型的动漫产品提供不同范围的授权许可，本合同项下仅针对表情包和创意动漫图片，授权范围为标准授权。
</p>

<h3>3.2 表情包和创意动漫图片的标准授权范围为：</h3>
<p>
  (1) 乙方授权甲方以在线广告、社交网络、移动设备广告、移动应用程序、软件（仅限于非售卖类软件）、电子贺卡，电子出版物（新闻网站、电子书、电子杂志和博客等）等数字形态使用动漫产品。<br>
  (2) 乙方授权甲方在报纸、杂志、宣传册、画册、折页、海报、展会摊位或零售点等印刷品上使用动漫产品，但上述印刷品不得印刷超过50万份。上述印刷品不包括报纸、杂志及图书封面及封底印刷，甲方有意在报纸、杂志及图书封面及封底印刷上使用的，应当单独另行取得乙方授权。<br>
  (3) 乙方授权甲方在广告或实物媒体中使用动漫产品，但不得在户外广告中使用。<br>
  (4) 甲方不得将动漫产品用于商标、商业标识或LOGO的设计、制作与使用中。
</p>

<h3>3.3</h3>
<p>
  除另有明确约定外，乙方授予甲方在全球范围内，非专有地，不可转让地，永久地在本协议约定的授权范围内使用动漫产品的权利。
</p>

<h2>第四章 权利与义务</h2>

<h3>4.1 甲方的权利与义务：</h3>
<p>
  4.1.1 甲方有权在授权许可范围内按本协议约定合理合法地使用动漫产品，不得以任何超出授权使用范围的方式使用动漫产品。<br>
  4.1.2 甲方有权要求乙方提供动漫产品授权书。<br>
  4.1.3 甲方应当依照本协议的约定，按时支付动漫产品许可费或动漫产品使用费。<br>
  4.1.4 未经乙方书面同意，甲方不得超越授权范围使用基于乙方动漫产品创作的新的作品或内容。甲方亦不得超出授权范围以使用、转授权、转让、转售、分发等侵犯乙方及动漫产品著作权人的著作权的方式使用上述新作品或内容。<br>
  4.1.5 甲方不得转售、转让、再分发、转授权或与第三方共享动漫产品使用权。<br>
  4.1.6 甲方不得在具有色情、诽谤、或欺诈性质的场景中使用动漫产品，亦不得以任何可能被视为诽谤、淫秽或非法的方式使用动漫产品。<br>
  4.1.7 甲方不得使用以下的方式描述动漫产品中出现的任何人（下称“模特”），亦不得将动漫产品用于以下用途：<br>
(1)与淫秽色情文学作品、淫秽色情影视作品、成人娱乐场所、陪伴服务、约会服务、美容整容、保健品类等有关；<br>

(2)参与烟草产品的广告或促销；<br>

(3)患有生理或心理疾病或用药治疗生理或心理疾病；<br>

(4)从事不道德或违法犯罪活动；<br>

(5)其他可能涉嫌侮辱、诽谤等贬损模特名誉或伤害模特情感或合法权益的方式。<br>
4.1.8 甲方不得以侵犯第三方的商标权、名誉权等权益的方式使用动漫产品。甲方不得将动漫产品（全部或部分）注册为商品商标、服务商标、集体商标或证明商标，或作为商品商标、服务商标、集体商标或证明商标的一部分。<br>
4.1.9 甲方不得以任何可能涉嫌虚假或引人误解的宣传等不正当竞争的方式使用动漫产品。<br>
4.1.10 甲方不得出售、出借、转让、许可或以任何方式允许第三人使用其青牛出关动漫网站账号，甲方应当是以其账号下载的动漫产品的最终使用人。<br>
甲方违反本条规定所造成的一切后果，由甲方和第三人承担连带责任，给乙方造成损失或其他不利后果的，乙方有权要求甲方和第三人承担连带赔偿责任。<br>
4.1.11 甲方理解并同意，开设青牛出关动漫网站帐号，同意青牛出关动漫网站《个人隐私信息保护政策》，方可成为乙方用户。为履行本协议之必须，甲方需向乙方提供甲方及/或甲方联系人的必要的个人信息。甲方同意乙方有权收集、使用、处理、存储、传输及授权包括乙方合作伙伴在内的第三方收集、使用、处理、存储、传输甲方提供的前述个人信息。青牛出关动漫网站《隐私政策》通过引用组成本协议不可分割的一部分。乙方有权随时修订《个人隐私信息保护政策》，在本协议期限内，甲方承诺同意乙方更新后的《个人隐私信息保护政策》。<br>
4.2 乙方的权利与义务：<br>
4.2.1 乙方有权保留本协议未明确授予甲方的全部权利。<br>
4.2.2 乙方有权收取动漫产品许可费和使用费。<br>
4.2.3 乙方有权依照市场情况决定动漫产品的价格，随时调整动漫产品的价格，动漫产品的实际销售价格以动漫产品购买者实际支付的价格为准。甲方理解并同意，乙方有权同时销售同一动漫产品的不同格式、不同大小的多个文件，各文件的定价或有不同，同一动漫产品不同授权模式的定价或有不同，不同套餐产品对同一动漫产品的定价或有不同。<br>
4.2.4 乙方有权根据动漫产品的质量、商业价值等，随时调整、限制或扩大动漫产品的授权许可类型，动漫产品购买者的许可使用范围以实际购买时为准。<br>
4.2.5 甲方使用动漫产品的方式违反法律法规或本协议约定的，乙方有权终止授权，并有权扣除、冻结甲方青牛出关动漫网站账号内的资金。<br>
4.2.6 甲方违反法律法规或本协议约定的，乙方有权限制甲方青牛出关动漫网站账号权限、关闭甲方青牛出关动漫网站账号。<br>
4.2.7 甲方的账号因任何原因关闭的，未经乙方书面同意，甲方不得建立新的账号。<br>
4.2.8 乙方应当保证，乙方在picopi.cn青牛出关动漫网站上展示的动漫产品均已拥有版权或获得了适当的授权，乙方有权代理销售及许可他人使用。<br>
4.2.9 甲方理解并同意：乙方网站在线销售的数字化商品属于不宜退、换货的特殊商品，甲方在购买动漫产品时已经明确了解和知悉动漫产品的所有属性，除经乙方确认，动漫产品确有质量问题外，动漫产品一经出售概不退换，乙方有权拒绝甲方的退、换货申请，且不承担任何责任。<br>
4.2.10 甲方理解并同意，甲方与乙方签约或甲方购买或下载乙方动漫产品的行为即表示，甲方授权乙方及乙方合作伙伴在宣传推广中合理地使用甲方的商标、企业名称、简称等，包括但不限于在任何媒介或乙方及乙方合作伙伴认为合适的宣传渠道中单独使用、与甲方购买、下载的动漫产品共同使用或与第三方商标、企业名称、简称等共同使用。<br>
</p>
<h2>第五章 违约责任</h2>
<p>5.1有下列情形之一的，乙方有权立即终止授权，限制甲方青牛出关动漫网站账号权限，扣除或冻结甲方账号内余额，关闭甲方账号等， 给乙方及乙方合作伙伴造成任何损失或任何不利法律后果的，乙方有权向甲方追偿：<br/>
(1)甲方以超出授权使用范围的方式使用动漫产品的；<br/>
(2)甲方转售、转让、再分发、转授权或与第三方共享动漫产品使用权的；<br/>
(3)甲方使用动漫产品的方式涉嫌淫秽色情、侮辱、诽谤、欺诈等违法情形的；<br/>
(4)甲方使用动漫产品的方式涉嫌侮辱、诽谤等贬损模特名誉的行为的；<br/>
(5)甲方使用动漫产品的方式涉嫌侵犯他人商标权等权益的；<br/>
(6)甲方使用动漫产品的方式涉嫌虚假宣传等不正当竞争行为的；<br/>
(7)甲方侵犯动漫产品作者、著作权人署名权的；<br/>
(8)甲方存在其他违反本协议约定或违法违规行为的。</p>
<p>
    5.2 甲方严格依照本协议约定的方式使用动漫产品，且没有违反与乙方签订的任何其他协议，如遭受第三方指控侵犯著作权的，乙方将为甲方提供必要的法律协助。甲方因此承担赔偿责任或其他不利法律后果的，有权就其遭受的直接损失（不包括可得利益损失），在本合同约定的赔偿额范围内向乙方申请补偿。
乙方有权决定对适用于上述补偿的任何索赔或诉讼、仲裁的处理、调解、和解或辩护策略。对于上述索赔或诉讼，甲方有权与乙方共同协商处置，参与调解、和解，并有权自费参与任何相关诉讼或仲裁；甲方同意，在乙方另有书面同意之前，乙方不承担甲方或甲方代表的任何法律费用和/或其他费用。
甲方应当在知悉或应当知悉相关索赔或诉讼、仲裁之日起5日内将相关信息以书面形式通知乙方。该通知必须包含甲方当时知晓的索赔或诉讼、仲裁的所有细节，包括但不限于提出索赔或诉讼、仲裁的主体名称及联系方式，律师函，公函，函件，法院传票，起诉书，证据，涉争动漫产品使用方式、涉争动漫产品编号、涉争动漫产品使用副本、提出索赔或诉讼、仲裁的性质和日期信息等。
甲方同意：乙方对因甲方修改动漫产品内容或超出授权范围使用动漫产品所造成的任何损害赔偿、费用或损失不承担任何责任。<br>
</p>
<p>
    5.3 各方同意：除本协议第6.2条中约定的情况外，在任何情况下，乙方对甲方使用或无法使用picopi.cn青牛出关动漫网站或动漫产品而产生的或与此相关的赔偿或补偿责任，累计不得超过乙方实际从甲方处收到的动漫产品许可费或动漫产品使用费。
</p>
<p>
    5.4 甲方理解并同意，鉴于互联网之特殊性质，以下非因乙方过错造成甲方损失的，乙方不承担赔偿责任：
(1)乙方网站遭受黑客攻击的；<br/>
(2)电信部门技术调整导致的；<br/>
(3)因政府管制而造成乙方网站暂时性关闭的；<br/>
(4)乙方网站遭受计算机病毒侵袭的；<br/>
(5)其他不可归责于乙方的情形。<br/>
</p>

<h2>第六章 协议的效力</h2>
<p>
    6.1 本协议于甲、乙双方签订之日起生效，除非本协议另有约定，本协议于甲方青牛出关动漫网站账号正式关闭之日起终止。<br>
6.2 本协议签订前，甲、乙双方就本协议所涉事项所达成的协议、合同、备忘录等文件均为本协议所取代，前述文件与本协议有任何不一致之处，以本协议为准。<br>
6.3 本协议任何条款被认定为无效或不具备强制执行力的，不影响本协议其他条款的效力，其他条款仍具有合同约束力和法律效力。<br>
6.4 本协议项下第8.2条争议解决条款为独立条款，不受本协议效力的限制，不因本协议届满或其他形式终止而丧失合同约束力和法律效力。<br>
</p>
<h2>第七章 协议的变更，解除和终止</h2>
<p>
    7.1 甲、乙双方协商一致，可书面变更本协议。<br>
7.2 因不可抗力导致本协议目的不能实现的，任何一方有权解除本合同。不可抗力是指本协议双方不能合理控制、不可预见或即使预见亦无法避免的事件。上述事件包括但不限于政府行为、地震、台风、洪水、火灾或其它天灾、战争、任何一方破产、遭到破产或申请破产或任何其它类似事件。<br>
7.3 甲方理解并同意：乙方可随时根据市场、法律、政策等情况对本协议进行修改变更，乙方变更本协议后应书面通知甲方，如甲方不同意变更后的本协议，则乙方有权暂停、关闭甲方的青牛出关动漫网站账号并终止本协议。<br>
7.4 甲方青牛出关动漫网站账号关闭时，本协议自动终止。<br>
7.5 本协议终止时，甲方无未支付款项，且不存在任何违约行为或违法违规行为的，本协议的终止不影响本协议第三章项下授权许可的效力。<br>
</p>
<h2>第八章 适用法律与争议解决</h2>
<p>
    8.1 适用法律
本协议之签署、效力、解释和执行以及本协议项下争议之解决均应适用中国法律
</p>
<p>
    8.2 争议解决
</p>
<p>
    8.2.1 各方确认：以甲方在乙方网站注册信息中的手机号码，作为各方之间往来以及仲裁机构仲裁和法院执行时的相关资料、通知、法律文书（包括但不限于仲裁裁决书、调解书等）的送达地址。 
各方确认，本协议各方、仲裁机构或者法院向本协议各方发出任何通知、法律文书（包括但不限于仲裁裁决书、调解书等），均可以邮政特快专递、快递、电子邮件或者短信方式或者仲裁机构或法院认为合适的其他方式发出，发送一方正确填写被送达方的手机号码即视为送达。如一方需变更住所地（或地址）、电子邮箱或者手机号码而未书面告知另一方、仲裁机构或法院，任何一方当事人、仲裁机构或者法院向上述原住所地（或地址）、原电子邮箱或者原手机号码发送法律文件，以及发送的法律文件被拒绝接收或者邮件系统或者短信系统退回的，均视为已经完成送达。
</p>
<p>
    8.2.2 法律选择/管辖权。本协议的签订、履行、解释、纠纷处理及与本协议相关的一切事务均适用中华人民共和国的法律。因本协议引起的一切纠纷双方均应友好协商，协商不成，任何一方均可向北京仲裁委员会申请仲裁。仲裁裁决是终局的，对双方有约束力，双方均应履行。
</p>
<p>
    8.2.3 各方在签署本协议时，对上述仲裁条款的含义已充分了解知悉，并不对此有任何异议
</p>

  </div>
</template>

<script>
export default {
  name: "goodsauth",
};
</script>

<style scoped lang='less'>
.user-agreement {
  font-family: Arial, sans-serif;
  color: black;
   width: 90%;
  height: 100%;
  padding: 100px 20px;
}

.user-agreement h1,
.user-agreement h2,
.user-agreement h3 {
  font-weight: bold;
  color: black;
  margin-top: 15px;
}

.user-agreement p {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/auth.vue